import { Component, OnDestroy, OnInit } from '@angular/core';
import { CheckPermission, momentCustomInstance as moment, sortList } from '@projects/shared/src/app/utils/helper';
import { LeadsService } from '../../services/leads.service';
import { ToastService } from '../../services/toast/toast.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-leads-assigned-modal',
  templateUrl: './leads-assigned-modal.component.html',
  styleUrl: './leads-assigned-modal.component.scss',
})
export class LeadsAssignedModalComponent implements OnInit, OnDestroy {
  selectedUsers = {
    toUserName: '',
    toUserLeadsCount: 0,
    fromUserName: '',
    fromUserLeadsCount: 0,
  };
  subscriptions: Array<Subscription> = new Array<Subscription>();
  constructor(public leadService: LeadsService, private toastService: ToastService) {
    this.subscriptions.push(
      this.leadService.isLeadListUpdated.subscribe((d) => {
        if (d.isUpdated) {
          this.selectedUsers = {
            toUserName: '',
            toUserLeadsCount: 0,
            fromUserName: '',
            fromUserLeadsCount: 0,
          };
        }
      })
    );
  }

  ngOnInit(): void {}

  getAgentLeads(agentUsername: string = '') {
    const payload = {
      Sightline: {
        StartDate: moment().utc().subtract(10, 'years').startOf('year').toISOString(),
        EndDate: moment().utc().endOf('day').toISOString(),
        Fields: '',
        FieldValues: '',
        Criteria: '',
        Limit: 15,
        Skip: 0,
        AdvFilters: [
          [
            {
              stage: 2,
              operatorName: 'contain',
              name: 'agent.agentUsername',
              value_str: '',
              value_int: -1,
              value_bool: false,
              values_list: [agentUsername],
              filter_type: 'string',
              field_type: 'string',
            },
          ],
        ],
        SearchMeta: [],
        SortMeta: {
          order: -1,
          field: 'CreatedOn',
        },
      },
    };
    return this.leadService.getOpenAssignedLeadsList(payload);
  }

  getList = (userDirection: string, userName: string): void => {
    this.getAgentLeads(userName).subscribe((data: any) => {
      if (userDirection === 'To') {
        this.selectedUsers.toUserLeadsCount = data.TotalCount;
        this.selectedUsers.toUserName = userName;
      } else if (userDirection === 'From') {
        this.selectedUsers.fromUserLeadsCount = data.TotalCount;
        this.selectedUsers.fromUserName = userName;
      }
    });
  };

  handleLeadsDropDownSelect(event: any, direction: string) {
    let agent = this.leadService.listOfAgents
      ? this.leadService.listOfAgents.find((a: any) => a.Id === event?.value)
      : {};
    if (agent) {
      if (direction === 'From') {
        this.selectedUsers.fromUserName = agent.UserName;
      } else {
        this.selectedUsers.toUserName = agent.UserName;
      }

      this.getList(direction, agent.UserName);
    }
  }

  handleLeadAssignment(operationType: string) {
    if (this.selectedUsers.fromUserLeadsCount === 0) {
      this.toastService.error('From user has zero leads');
      return;
    }
    this.leadService.handleTransferLeads(operationType, this.selectedUsers);
  }

  ngOnDestroy(): void {
    //* Clean up work
    this.leadService.clearUserForm();
    this.selectedUsers = {
      toUserName: '',
      toUserLeadsCount: 0,
      fromUserName: '',
      fromUserLeadsCount: 0,
    };
    this.subscriptions.forEach((s: Subscription) => s.unsubscribe());
  }
}
